// npm
import React, { memo } from 'react'
import { useStaticQuery, graphql } from 'gatsby'

// src
import ContentSectionBgImage from './ContentSectionBgImage'
import BgImageSwiper, { slide } from '@molecules/swipers/BgImageSwiper'

const ContentSectionRecentProjects = () => {
  const data = useStaticQuery<Queries.RecentProjectsSwiperQuery>(graphql`
    query RecentProjectsSwiper {
      allDatoCmsProject(
        limit: 5
        sort: { fields: [meta___createdAt], order: [DESC] }
      ) {
        edges {
          node {
            originalId
            model {
              apiKey
            }
            slug
            snapSectionHero {
              smallHeading
              mainHeadingNode {
                childMarkdownRemark {
                  html
                }
              }
            }
            description
            imageLandscape: heroImage {
              gatsbyImageData(
                width: 1600
                layout: FULL_WIDTH
                imgixParams: { ar: "4:3", fit: "crop", crop: "focalpoint" }
              )
            }
            imagePortrait: heroImage {
              gatsbyImageData(
                width: 1600
                layout: FULL_WIDTH
                imgixParams: { ar: "1:2", fit: "crop", crop: "focalpoint" }
              )
            }
          }
        }
      }
    }
  `)

  let slides: slide[] = []
  data.allDatoCmsProject.edges.map((item: any) => {
    const slide: Queries.DatoCmsProject = item.node
    slides.push({
      id: slide.id,
      children: (
        <ContentSectionBgImage
          keyId={slide.id}
          imagePortrait={slide.imagePortrait.gatsbyImageData}
          imageLandscape={slide.imageLandscape.gatsbyImageData}
          subtitle={slide.snapSectionHero[0].smallHeading}
          mainHeading={
            slide.snapSectionHero[0].mainHeadingNode.childMarkdownRemark.html
          }
          text={slide.description}
          forceHeadingBorder
          button={{
            label: 'View Project',
            isInternal: true,
            internalLink: {
              slug: slide.slug,
              model: {
                apiKey: slide.model.apiKey,
              },
            },
          }}
        />
      ),
    })
  })

  return <BgImageSwiper slides={slides} withNav />
}

export default memo(ContentSectionRecentProjects)
